var render = function render(){var _vm=this,_c=_vm._self._c;return _c('category',{attrs:{"name":"Messages","categorystyle":"messages_category"}},[_c('block',{attrs:{"type":"send_a_chat_message"}}),_c('block',{attrs:{"type":"display_action_bar"}}),_c('block',{attrs:{"type":"display_title"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }